import React, { useEffect, useState } from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
import StackProgress from "./skillProgress/skillProgress";
import WorkExperience from "./workExperience/WorkExperience";
import Achievement from "./achievement/Achievement";
import Contact from "./contact/Contact";
import Footer from "../components/footer/Footer";
import Top from "./topbutton/Top";
import { StyleProvider } from "../contexts/StyleContext";
import "./Main.css";

const Main = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
    setIsDark(darkPref.matches);
  }, []);
  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{ isDark: isDark, changeTheme: changeTheme }}>
        <Header />
        <Greeting />
        <Skills />
        <StackProgress />
        <Achievement />
        <WorkExperience />
        <Contact />
        <Footer />
        <Top />
      </StyleProvider>
    </div>
  );
};

export default Main;
